import { stateGo } from 'redux-ui-router';
import { UPGRADE_TEXT } from '../constants';
import { selectUpgradeProduct } from 'logic/signup';
import {
  upgradeSubscription,
  selectHasBundleSubscription,
  selectHasNutritionSubscription,
  selectHasWorkoutSubscription,
  selectSubscription,
} from 'logic/member';

export const Upgrade = {
  template: `
    <modal-upgrade
      ng-if="$ctrl.showModal"
      error-message="$ctrl.errorMessage"
      text="$ctrl.upgradeText"
      is-bundle-upgrade="$ctrl.isBundleUpgrade"
      is-loading="$ctrl.isLoading"
      on-submit="$ctrl.onSubmit($ctrl.subscriptionId, $ctrl.voomeProductId)">
    </modal-upgrade>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
      },

      $onDestroy() {
        this.disconnect();

        if (this.unsubscribe) {
          this.unsubscribe();
        }
      },

      onSubmit(subscriptionId, voomeProductId) {
        this.upgradeSubscription(subscriptionId, voomeProductId);

        this.unsubscribe = $ngRedux.subscribe(() => {
          const subscription = selectSubscription($ngRedux.getState().member);
          const { slug } = this.upgradeText;

          if (subscription.voomeProductId === voomeProductId) {
            this.unsubscribe();
            this.stateGo('welcomeUpgrade', { slug });
          }
        });
      },

      mapState({ member, router, signup }) {
        const key = router.currentState.name.split('.')[0];
        const subscription = selectSubscription(member);
        const voomeProduct = selectUpgradeProduct(
          signup,
          subscription.voomeProductId
        );

        return {
          errorMessage: member.error && member.message,
          isLoading: member.isLoading,
          isBundleUpgrade:
            selectHasNutritionSubscription(member) ||
            selectHasWorkoutSubscription(member),
          showModal: !selectHasBundleSubscription(member),
          subscriptionId: subscription.id,
          upgradeText: UPGRADE_TEXT[key],
          voomeProductId: voomeProduct.id,
        };
      },

      mapDispatch() {
        return {
          upgradeSubscription,
          stateGo,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Upgrade.js